<span class="PGUserStatus">
    <i class="fa fa-xs fa-circle text-{{ statusClass }} me-1"></i>
    @if (showName) {
        <span>{{ displayName }}</span>
    }
</span>
